import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { FONTS, COLORS } from "../utils/styleConstants";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: linear-gradient(90deg,rgb(255, 199, 181) 0%, #ffe4d6 25%, #f5f9ff 75%,rgb(219, 237, 251) 100%);
  border-radius: 15rem;
  padding: 2.5rem 6rem;
  max-width: 800px;
  width: 90%;
  min-height: 400px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  @media (max-width: 768px) {
    padding: 2rem 2.5rem;
    max-width: 600px;
    width: 95%;
    min-height: 350px;
    border-radius: 15rem;
  }
  
  @media (max-width: 480px) {
    padding: 1.5rem 1.5rem;
    max-width: 350px;
    width: 95%;
    min-height: 300px;
    border-radius: 15rem;
  }
`;

const ModalTitle = styled.h2`
  color: ${COLORS.SECONDARY};
  font-family: 'WorkSans', sans-serif;
  font-size: 2.75rem;
  font-weight: 300;
  margin: 0 0 1rem 0;
  text-align: center;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    font-size: 2rem;
    line-height: 2.2rem;
    margin-bottom: 1rem;
    max-width: 350px;
  }
  
  @media (max-width: 480px) {
    font-size: 1.25rem;
    line-height: 1.4rem;
    margin-bottom: 0.75rem;
    max-width: 280px;
  }
`;

const ModalMessage = styled.p`
  color: ${COLORS.SECONDARY};
  font-family: 'WorkSans', sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  text-align: center;
  margin: 0 0 1.5rem 0;
  max-width: 450px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    line-height: 1.4rem;
    margin-bottom: 1.5rem;
    max-width: 320px;
  }
  
  @media (max-width: 480px) {
    font-size: 0.85rem;
    line-height: 1.2rem;
    margin-bottom: 1.25rem;
    max-width: 260px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;

const PrimaryButton = styled.button`
  background-color: transparent;
  color: ${COLORS.ACCENT};
  border: 1px solid ${COLORS.ACCENT};
  border-radius: 2rem;
  padding: 0.625rem 1.75rem;
  font-family: 'WorkSans', sans-serif;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;

  &:hover {
    background-color: ${COLORS.ACCENT};
    color: white;
    transform: translateY(-1px);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(255, 112, 87, 0.3);
  }
  
  @media (max-width: 768px) {
    padding: 0.5rem 1.5rem;
    font-size: 0.85rem;
    min-width: 100px;
  }
  
  @media (max-width: 480px) {
    padding: 0.35rem 1rem;
    font-size: 0.75rem;
    min-width: 70px;
  }
`;

const InsufficientCreditsModal = ({ 
  isOpen, 
  onClose, 
  creditsAvailable, 
  creditsRequired 
}) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handlePurchaseCredits = () => {
    navigate("/purchase");
  };

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalTitle>¡Parece que te has quedado sin ofertas!...</ModalTitle>
        
        <ModalMessage>
          Para poder enviar tu oferta vinculante puedes escoger entre uno de nuestros paquetes:
        </ModalMessage>

        <ButtonContainer>
          <PrimaryButton onClick={handlePurchaseCredits}>
            Seleccionar
          </PrimaryButton>
        </ButtonContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default InsufficientCreditsModal; 